<template>
  <div class="product-list-inner">
    <div class="product-list favorites page-wrapper">

        <div class="product-list-loader center" v-loading="loading"  :class="{'hide': !loading}"></div>

        <div class="product-list-title" v-if="!loading">
        <div class="product-list-title-left">
          {{$store.state.favorites.length}} saved {{ $store.state.favorites.length === 1 ? 'item' : 'items' }}
        </div>
        <div class="product-list-title-right">
          View
          <div class="product-list-title-view-switch-desktop">
            <a @click.prevent="setGridView('desktop', 2)" href="#" :class="{'active': $store.state.view.desktop === 2}">2</a>
            <a @click.prevent="setGridView('desktop', 3)" href="#" :class="{'active': $store.state.view.desktop === 3}">3</a>
            <a @click.prevent="setGridView('desktop', 4)" href="#" :class="{'active': $store.state.view.desktop === 4}">4</a>
          </div>
          <div class="product-list-title-view-switch-mobile">
            <a @click.prevent="setGridView('mobile', 1)" href="#" :class="{'active': $store.state.view.mobile === 1}">1</a>
            <a @click.prevent="setGridView('mobile', 2)" href="#" :class="{'active': $store.state.view.mobile === 2}">2</a>
          </div>
        </div>
      </div>

      <div class="product-list-inner" :class="'desktop-view-' + $store.state.view.desktop + ' mobile-view-' + $store.state.view.mobile">

          <div class="product-list-item"
               :class="{'selected': isInSelects(item)}"
               v-for="item in computedProducts"
               :key="'product_' + item.id">
              <div class="product-list-item-inner">
                <div @click.prevent="toggleSelects(item)" class="product-list-item-link">
                  <img :src="getbase64EncodedImage(item.attributes)" />
                  <div v-if="isInSelects(item)" class="product-list-item-selected"></div>
                  <div @click.stop="productClickAction(item)" class="product-list-item-more"></div>
                </div>
                <div class="product-list-item-details">
                  <a class="product-list-item-details-meta" @click.prevent="removeFromFavorites(item)">remove</a>
                </div>
              </div>
          </div>

        <template v-if="favouritesLoaded">
          <div class="product-list-item"
              :class="{'selected': item.selected}"
              v-for="item in $store.state.favorites.filter(function (item) {
                return computedProducts.findIndex(function (product) { return item === parseInt(product.id) }) === -1
              })"
              :key="'removed_' + item">

            <div class="product-list-item-inner">
              <a class="product-list-item-link removed" ></a>
              <div class="product-action removed">
                <p class="product-action-item removed">
                  {{item}} - removed from Extensis
                </p>
              </div>
            </div>
            <div class="product-list-item-details">
              <a class="product-list-item-details-meta" @click.prevent="removeFromFavorites(item)">remove</a>
            </div>
          </div>
        </template>

          <div v-if="scrollLoading" v-loading="scrollLoading" class="product-list-scroll-loader helper"></div>

        </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/services/api'
// import { EventBus } from '@/services/eventbus'

export default {
  name: 'SavedItems',
  metaInfo () {
    return {
      title: 'Saved Items'
    }
  },
  data () {
    return {
      bulkSelect: false,
      productSelect: {
        clickCount: 0,
        clickTimer: null,
        clickDelay: 300
      },
      loading: false,
      scrollLoading: false,
      favouritesLoaded: false
    }
  },
  created () {
    window.addEventListener('scroll', this.scroll)
  },
  mounted () {
    if (this.$store.state.favoritesLoadIndex < this.$store.state.favorites.length) {
      this.loadData()
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scroll)
  },
  computed: {
    computedProducts: function computedProducts () {
      return this.$store.state.favoritesItems
    }
  },
  methods: {
    scroll () {
      let bottomOfWindow = (Math.ceil(Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) + 3) > Math.ceil(document.documentElement.offsetHeight)
      if (bottomOfWindow && !this.scrollLoading && this.$store.state.favorites.length > this.$store.state.favoritesItems.length) {
        this.loadData()
      }
    },
    setGridView (type, value) {
      this.$store.dispatch('setGridView', {
        desktop: type === 'desktop' ? value : this.$store.state.view.desktop,
        mobile: type === 'mobile' ? value : this.$store.state.view.mobile
      })
    },
    getbase64EncodedImage (item) {
      if (typeof item['com.extensis.portfolio.Preview'] !== 'undefined') {
        return 'data:image/jpeg;base64,' + item['com.extensis.portfolio.Preview'][0].replace(/(\r\n|\n|\r)/gm, '')
      } else if (typeof item['Thumbnail'] !== 'undefined') {
        return 'data:image/jpeg;base64,' + item['Thumbnail'][0].replace(/(\r\n|\n|\r)/gm, '')
      }
    },
    loadData () {
      this.scrollLoading = true

      const index = this.$store.state.favoritesLoadIndex || 0

      const ids = this.$store.state.favorites.slice(index,
        index + parseInt(process.env.VUE_APP_API_PAGINATION_SIZE))

      this.$store.dispatch('setFavoritesLoadIndex', index + parseInt(process.env.VUE_APP_API_PAGINATION_SIZE))

      if (!ids.length) {
        this.scrollLoading = false
        return
      }

      HTTP({
        method: 'GET',
        url: '/api/v1/favorites/assets',
        params: {
          ids: ids
        },
        crossdomain: true
      }).then(response => {
        this.$store.dispatch('setFavoritesItems', response.data.data.assets)
        if (this.$store.state.favoritesLoadIndex >= this.$store.state.favorites.length) {
          this.favouritesLoaded = true
        }
        this.scrollLoading = false
      }).catch(() => {
        this.$store.dispatch('setFavoritesItems', [])
        this.scrollLoading = false
      })
    },
    isInSelects (item) {
      return this.$store.state.request.findIndex(function (req) {
        return parseInt(req.id) === parseInt(item.id)
      }) !== -1
    },
    toggleSelects (item) {
      if (this.isInSelects(item)) {
        this.removeFromCart(item)
      } else {
        this.addToCart(item)
      }
    },
    removeFromFavorites (product) {
      this.loading = true
      let productId = typeof product === 'object' ? product.id : product
      HTTP({
        method: 'DELETE',
        url: '/api/v1/favorites',
        crossdomain: true,
        data: {
          ids: [productId]
        }
      })
        .then(response => {
          this.loading = false
          if (response.data.data) {
            this.$notify({
              // title: 'Success',
              message: 'Removed from saved items',
              type: 'success',
              position: 'bottom-right',
              duration: 1750
            })
            this.$store.dispatch('setFavorites', response.data.data)
            if (typeof product === 'object') {
              this.computedProducts.splice(this.computedProducts.findIndex(function (item) { return item.id === product.id }), 1)
            }
          }
        })
        .catch((error) => {
          this.loading = false
          this.$notify({
            // title: 'Error',
            dangerouslyUseHTMLString: true,
            message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
        })
    },
    productClickAction (item) {
      this.$router.push('/products/' + item.id)
    },
    addToCart (product) {
      this.$store.dispatch('addRequestItem', product)
      this.$notify({
        message: 'Added to selects',
        type: 'success',
        position: 'bottom-right',
        duration: 1750
      })
    },
    removeFromCart (item) {
      this.$store.dispatch('removeRequestItem', {
        item: item,
        all: false
      })
      this.$notify({
        message: 'Removed from selects',
        type: 'success',
        position: 'bottom-right',
        duration: 1750
      })
    }
  }
}
</script>
